<script>
import { ArrowUpIcon } from "vue-feather-icons";

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import { post } from "@/assets/js/utils";
import config from "@/config.json";

/**
 * Illustrator install page.
 *
 * Illustrator is new in 4.0 — there was no v3 product, so unlike the other
 * per-tool pages this one has no history to restore. It follows the same
 * shape as the rest: ask /api/latest-release for its own product id and use
 * whatever URL comes back, so a release only has to touch the app_version
 * row rather than this file. Ai.Mirror's row is status=0, which the website
 * API reads and the plugin update-check paths ignore.
 */
export default {
  data() {
    const ua = navigator.userAgent.toLowerCase();
    const os = ua.indexOf("mac") > 0 ? "mac" : "win";
    return {
      downloadUrl: "#",
      os: os,
      selected: os,
      release: {
        app: "",
        vcname: "",
        vc: 0,
        mac_url: "",
        win_url: "",
        created_at: "",
      },
    };
  },
  mounted() {
    this.getRelease();
  },
  methods: {
    async getRelease() {
      try {
        const data = await post(`${config.api.latestrelease}`, { app: "Ai.Mirror" });
        if (data.errno === 0) {
          this.release = data.data;
          this.downloadUrl = this.selected === "mac" ? this.release.mac_url : this.release.win_url;
        }
      } catch (e) {}
    },
    toggleOS() {
      this.selected = this.selected === "mac" ? "win" : "mac";
      this.downloadUrl = this.selected === "mac" ? this.release.mac_url : this.release.win_url;
    },
  },
  components: {
    Navbar,
    Footer,
    ArrowUpIcon,
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-half-170 d-table w-100" id="home">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-7">
            <div class="title-heading mt-4">
              <h1 class="heading mb-3">{{ $t('illustrator.title') }}</h1>
              <p class="para-desc text-muted">
                {{ $t('illustrator.description') }}
                <span class="text-danger font-weight-bold">{{ $t('illustrator.version_support') }}</span>
              </p>
              <div class="mt-4 pt-2">
                <a href="#" @click.prevent="toggleOS" class="btn btn-icon btn-pills"
                   :class="{'btn-info': selected === 'win', 'btn-primary': selected === 'mac'}">
                  <i class="mdi" :class="{'mdi-microsoft-windows': selected === 'win', 'mdi-apple': selected === 'mac'}"></i>
                </a>
                <a :href="downloadUrl"
                   onclick="_czc.push(['_trackEvent', 'app', 'download', 'illustrator']);"
                   class="btn ml-2"
                   :class="{'btn-info': selected === 'win', 'btn-primary': selected === 'mac'}">
                  {{ $t('illustrator.download') }} <i class="mdi mdi-download"></i>
                </a>
              </div>
              <div class="mt-2">
                <span class="badge badge-pill badge-outline-light">
                  {{ $t('photoshop.version') }} {{ release.vcname }}，{{ $t('photoshop.update_time') }} {{ release.created_at | formatDate }}
                </span>
              </div>
              <div class="mt-4 pt-2">
                <h2 class="h3">{{ $t('illustrator.install.title') }}</h2>
                <ul class="list-unstyled">
                  <li v-for="(item, index) in $t('illustrator.install.steps')" :key="index">
                    <span class="text-primary h5 mr-2"><i class="uil uil-check-circle align-middle"></i></span>
                    <span v-html="item"></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <img width="1280" height="903" loading="eager" fetchpriority="high" src="/images/photoshop/mobile-app.png" :alt="$t('alt.mobile_app')" class="img-fluid" />
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <Footer />

    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top"
       id="back-to-top" v-scroll-to="'#topnav'">
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
